<template>
  <v-row class="ma-1">
    <v-col md="12" cols="12">
      <v-toolbar class="" color="primary" dark flat>
        <v-toolbar-title>Katastrálne územia</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col md="12" cols="12">
      <v-treeview
        v-if="kraje.length > 0"
        :items="kraje"
        :open-on-click="true"
        :load-children="fetchItems"
        activatable
        :active.sync="activeItem"
        dense
      >
        <template v-slot:label="{ item }">
          <span v-if="item.typ === 'LOK'">
            <router-link :to="{ name: 'lokalita', params: { id: item.id } }">
              Lokalita {{ item.name }}
            </router-link>
          </span>
          <span v-else>
            {{ item.id }} - {{ item.name }} ({{ item.pocet }})
          </span>
        </template>
      </v-treeview>
      <v-overlay :value="loading">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    kraje: [],
    activeItem: null,
    loading: true
  }),

  components: {},

  computed: {},

  methods: {
    readKraje: async function() {
      try {
        this.loading = true
        let response = await this.$axios.get("/uzemia/0/START")
        if (response.status === 200) {
          let items = response.data
          items.forEach(item => {
            item.children = []
          })
          this.kraje = items
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
      this.loading = false
    },
    fetchItems: async function(item) {
      let items = []
      try {
        console.log("fetchItems", item)
        this.loading = true
        let response = await this.$axios.get(`/uzemia/${item.id}/${item.typ}`)
        if (response.status === 200) {
          items = response.data
          if (items !== null) {
            items.forEach(item => {
              if (item.typ !== "LOK") {
                item.children = []
              }
            })
          }
          item.children = items
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
      this.loading = false
    }
  },
  mounted: async function() {
    console.log("uzemia mounted")
    this.$store.dispatch("fetchme", this.$axios)
    this.readKraje()
  }
}
</script>
